import { fetchRequirementById } from './fetchRequirementByIdThunk';
export default fetchRequirementById;
